import { render } from "./update-password.vue?vue&type=template&id=9d07ad24&ts=true"
import script from "./update-password.vue?vue&type=script&lang=ts"
export * from "./update-password.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__